import { token } from '@atlaskit/tokens';
import { getGridTemplateColumns } from '@databases/frontend/TableLayout';
import { Database } from '@databases/types/database';
import React, { FunctionComponent } from 'react';

import QuickCalculationsSelect from './QuickCalculationSelect';

interface QuickCalculationsRowProps {
  columnWidths: number[];
  database: Database;
  containerWidth: number;
}

const QuickCalculationsRow: FunctionComponent<QuickCalculationsRowProps> = ({
  columnWidths,
  database,
  containerWidth,
}) => {
  return (
    <tr
      style={{
        display: 'grid',
        gridTemplateColumns: getGridTemplateColumns(columnWidths),
        marginLeft: '3px',
      }}
    >
      {database.fields.map((fieldId) => {
        const widthIndex = database.fields.indexOf(fieldId);
        const isFirst = widthIndex === 0;
        const isLast = widthIndex === database.fields.length - 1;
        const totalContainerWidth = columnWidths.reduce((acc, width) => acc + width, 0);
        // rounding to blur small floating point differences
        const columnWidthsEqualContainerWidth =
          Math.round(totalContainerWidth) === Math.round(containerWidth);

        return (
          <td
            key={fieldId}
            width={
              isLast && columnWidthsEqualContainerWidth
                ? columnWidths[widthIndex] - 10 - 8 // subtract the margins from either side of the database
                : columnWidths[widthIndex]
            }
            style={{
              marginLeft: isFirst ? token('space.100') : token('space.0'),
            }}
          >
            <QuickCalculationsSelect
              fieldId={fieldId}
              database={database}
              width={columnWidths[widthIndex]}
            />
          </td>
        );
      })}
    </tr>
  );
};

export default QuickCalculationsRow;
